import apiService from '@/services/apiService';

const actions = {
  getClaimedBenefit({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxelian-club/user-membership/find-benefits-with-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAbout({ commit }, payload) {
    apiService.get(`about-us/${payload}`)
      .then((response) => {
        commit('getAbout', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  postProcessBenefit({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxelian-club/user-membership/benefit-update-to-process', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postReceivedBenefit({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxelian-club/user-membership/benefit-update-to-done', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

};

export default actions;
